import * as lib from 'Root/lib/lib.js'

const IN_VIEWPORT_CLASS = 'in-viewport'
const IN_VIEWPORT_PERCENT = 0.8

class InViewport {
    constructor(element) {
        if (!element) return

        this.element = element

        this.checkElemPosition()

        window.addEventListener('scroll', () => {
            this.checkElemPosition()
        })

        window.addEventListener('resize', () => {
            this.checkElemPosition()
        })
    }

    checkElemPosition() {
        if (this.element.classList.contains(IN_VIEWPORT_CLASS)) {
            return
        }

        const headerVisible =
            window.innerWidth < lib.breakpoints.desktop || !document.body.classList.contains('header-hidden')
        const elemOffset = $(this.element).offset().top
        const elemHeight = $(this.element).outerHeight()
        const elemBtmCheckpoint = elemOffset + elemHeight * IN_VIEWPORT_PERCENT
        const viewportTop = headerVisible ? window.pageYOffset + $('.header__bar').outerHeight() : window.pageYOffset
        const viewportBtm = window.pageYOffset + window.innerHeight

        if (elemBtmCheckpoint < viewportBtm && elemBtmCheckpoint > viewportTop) {
            this.element.classList.add(IN_VIEWPORT_CLASS)
        }
    }
}

export default InViewport
